import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

/** The device frame. `fixed` pins height (chat) instead of min-height. */
export function Screen({
  children,
  className,
  fixed,
}: {
  children: ReactNode;
  className?: string;
  fixed?: boolean;
}) {
  return <main className={`lcd${fixed ? ' fixed' : ''}${className ? ' ' + className : ''}`}>{children}</main>;
}

/** Task-screen header: back-to-menu control, centred round/screen label, a right slot. */
export function TopBar({
  title,
  sub,
  right,
}: {
  title: string;
  sub?: string;
  right?: ReactNode;
}) {
  const nav = useNavigate();
  return (
    <header className="top">
      <button className="back" aria-label="Back to menu" onClick={() => nav('/')}>
        ◀
      </button>
      <div className="mid">
        <div className="r">{title}</div>
        {sub ? <div className="p">{sub}</div> : null}
      </div>
      <span className="t">{right}</span>
    </header>
  );
}

/** A centred full-panel message (empty states, confirmations, errors). */
export function CenterNote({ title, children }: { title?: string; children?: ReactNode }) {
  return (
    <div className="center-note">
      {title ? <h2>{title}</h2> : null}
      {children}
    </div>
  );
}
